import { render, staticRenderFns } from "./NewDeliveryOrder.vue?vue&type=template&id=4f28f441&scoped=true&"
import script from "./NewDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./NewDeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./NewDeliveryOrder.vue?vue&type=style&index=1&id=4f28f441&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28f441",
  null
  
)

export default component.exports